import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

/**
 * Allowlist POSITIVA para exibir o botão "Aprovar" (Step 5 — Cotação,
 * status `aguardando_analise`): resolve `canApprove = true` apenas quando
 * o usuário pertence a um grupo Cognito de subscrição da seguradora
 * (`insurer.underwriter` ou `insurer.administrator`).
 *
 * Não reutiliza `requireInsurerUnderwritingAccess()` (`shared/utils`) — ela
 * é uma DENYLIST (`!isCommercialInsurerUser(groups)`) pensada para
 * route-guards, que retorna `true` para corretores e qualquer perfil não
 * comercial da seguradora; usá-la aqui mostraria "Aprovar" a corretores, o
 * oposto do pretendido. Mirror de `useIsBrokerUser`
 * (`shared/hooks/use-is-broker-user.hook.ts`): mesmo padrão
 * `useEffect`/`useState`/`isLoading`, via `useAuth().checkUserGroups`.
 */
export function useCanApproveRd() {
  const { checkUserGroups } = useAuth();
  const [canApprove, setCanApprove] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups([
        UserGroup.INSURER_UNDERWRITER,
        UserGroup.INSURER_ADMINISTRATOR,
      ]);
      setCanApprove(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { canApprove, isLoading };
}
